import {InputType, FormControlType, IFormConfig} from 'marine-panel-common-web';

export const marinaDescriptionFormConfig = (value?: any): IFormConfig => {
    return {
        controlType: 'form',
        class: 'default-form',
        dataAccessor: (data: any) => data,
        outputDataMapper: (data: any, previousStateSnapshot: any) => {
            Object.assign(previousStateSnapshot, data);
            return previousStateSnapshot;
        },
        controls: [
            {
                key: 'marina_description',
                controlType: 'group',
                class: 'row',
                controls: {
                    description: {
                        controlType: 'control',
                        defaultValue: value ? value : '',
                        formControlType: FormControlType.TEXTAREA,
                        validationRules: [],
                        placeholder: '',
                        isLabelHidden: false,
                        label: '',
                        type: InputType.TEXT,
                        hostClass: 'col-xl-12 form-control',
                    },
                },
            },
        ],
    };
};
